<template>
  <div class="mb-4 lg:mb-8 flex-shrink-0">
    <h3 class="text-xl font-semibold mb-4">
      {{
        currentStep === -1
          ? errorStep.type === "success"
            ? "Success!"
            : "Error"
          : steps[currentStep].title
      }}
    </h3>
    <div class="flex gap-1">
      <div
        v-for="(step, index) in steps"
        :key="step.id"
        class="flex-1 h-2 rounded-full transition-all duration-300"
        :class="[
          currentStep === -1
            ? errorStep.type === 'success'
              ? 'bg-green-500'
              : 'bg-red-500'
            : index <= currentStep
              ? 'bg-primary-500'
              : 'bg-gray-200'
        ]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Step {
  id: number
  title: string
}
interface ErrorState {
  active: boolean
  type: 'success' | 'error' | null
  message: string | null
}
defineProps<{
  steps: Step[]
  currentStep: number
  errorStep: ErrorState
}>()
</script>
